import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { GoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login";
import { useDispatch } from "react-redux";

import Modal from "../../components/Modal";
import { setUser } from "../../store/slices/authSlice";

const SignInModal = ({ ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const googleLoginSuccess = (response) => {
    // console.log(response);
    setIsLoading(true);

    axios
      .post("/auth/google-login", { credential: response.credential })
      .then((res) => {
        dispatch(setUser({ token: res.data.token, ...res.data.user }));
        rest.toggleShow();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Uh Oh! Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const googleLoginFailure = (err) => {
    toast.error("Uh Oh! Something went wrong");
    console.log(err);
    setIsLoading(false);
  };

  const facebookSuccess = (response) => {
    // console.log(response);
    setIsLoading(true);

    axios
      .post("/auth/facebook-login", {
        accessToken: response.accessToken,
        userID: response.userID,
      })
      .then((res) => {
        dispatch(setUser({ token: res.data.token, ...res.data.user }));
        rest.toggleShow();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Uh Oh! Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const facebookFailure = (err) => {
    console.log(err);
    toast.error("Uh Oh! Something went wrong");
    setIsLoading(false);
  };

  return (
    <Modal id="signin-modal" title="SIGNUP/LOGIN" {...rest}>
      <div className="text-center">
        <form action="">
          <GoogleLogin
            buttonText={isLoading ? "Loading..." : "Login with google"}
            onSuccess={googleLoginSuccess}
            onFailure={googleLoginFailure}
          />
          <div className="fb-wrapper">
            <FacebookLogin
              appId="1127823614500397"
              autoLoad={false}
              fields="name,email"
              callback={facebookSuccess}
              onFailure={facebookFailure}
              textButton={isLoading ? "Loading..." : "Login with Facebook"}
              icon="fa-facebook"
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default SignInModal;
